'use client';

import clsx from 'clsx';
import { Styles } from './virtual-euro-float-button.style';
import Image from 'next/image';
import { CloseRoundIcon } from '@/components/icons/svg-icons';
import { Button } from '@nf/ui';
import { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useLocale } from 'next-intl';
import { convertCultureToRef } from '@/utils/common-util';
import { useAuthToken } from '@/store/auth';
import { useParams } from 'next/navigation';
import { useAccountStatus } from '@/hooks/query/account';
import { virtualWeidgetService } from '@/services/virtual-sport-widget.service';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import webStorageKeys from '@/constants/web-storage-keys';
import { AccountActStatus } from '@nf/utils-common/constants';

export const VirtualEuroFloatButton = () => {
	const floatVirtualObj = sessionStorage.getItem(webStorageKeys.FLOATVIRTUALWIDGET);
	const VirtualButtonDefaultValue = (floatVirtualObj) ? JSON.parse(floatVirtualObj)?.closed !== 1 : true;
	const { SiteConfigsData } = useGetSiteConfigs();
	const [showFloat, setShowFloat] = useState(VirtualButtonDefaultValue);
	const locale = useLocale();
	const params = useParams();
	const authToken = useAuthToken();
	const isBefore = !Boolean(authToken);
	const { data: actStatus } = useAccountStatus();
	const sportId = Number(params.sport);

	const CloseFloat = () => {
		sessionStorage.setItem(webStorageKeys.FLOATVIRTUALWIDGET, JSON.stringify({ 'closed': 1 }));

		setShowFloat(false);
	}

	const OpenVirtualWidgetModal = () => {
		virtualWeidgetService.displayVirtualWeidgetModal(true);
	}

	const containerRef = useRef(null);
	return (
		<>
			{
				showFloat && !isBefore && actStatus === AccountActStatus.Deposited && SiteConfigsData?.EnableSabaEuro && (sportId == 1 || sportId == 2 || sportId == 997) ? (
					<>
						<motion.div
							className={Styles.float}
							transition={{ ease: 'easeOut', duration: .2 }}
							drag
							dragConstraints={containerRef}
						>
							<Button variant="icon"
								className={Styles.floatButton}
								onClick={OpenVirtualWidgetModal}
							>
								<Image
									src={`/images/promotion/virtual-euro2024/${SiteConfigsData?.EnableFilterSaba ? 'float-virtual' : 'float-saba-virtual'}_${convertCultureToRef(locale)}.png`}
									alt=""
									width="65"
									height="65"
									style={{ pointerEvents: 'none' }}
								/>
							</Button>
							<Button variant="icon"
								className={Styles.closeButton}
								onClick={CloseFloat}
							>
								<CloseRoundIcon />
							</Button>
						</motion.div>
						<div ref={containerRef} className={Styles.container}></div>
					</>
				) : null
			}
		</>
	)
}
